export default {
  defaults: {
    debug: true,
    contentful_api: {
      space: 'fe7rxo4a5y0c',
      domain_entry_id: '4cLNkAznOoKEIso6wKKk8W',
      // website_entry_id: '3EB5DLgEVWK6Aaii4kQAMm',
      access_token: 'f95045990e9a93b4e46efdc1531a7e273de3a9eefb5d2401fd53e3df511adf46',
      pat: 'CFPAT-fccd93be745ca1c4414ef99a2ecc7f9d9c4f2e3539f859a81afe299cb0332e77',
      content_types: 'https://cdn.contentful.com/spaces/fe7rxo4a5y0c/content_types',
      entries: 'https://cdn.contentful.com/spaces/fe7rxo4a5y0c/entries/',
      assets: 'https://cdn.contentful.com/spaces/fe7rxo4a5y0c/assets/',
      limit: 10
    },
    socket_api: {
      async: true,
      host: '',
      token: '',
      tokenName: 'token'
    },
    socket: {
      async: true,
      host: '',
      token: '',
      tokenName: 'token'
    },
    mcAction: 'https://digigurus.us16.list-manage.com/subscribe/post?u=09283e07454e068bd65340edd&amp;id=3d6aaf4c34'
  }
}



// WEBPACK FOOTER //
// ./src/config/global.js